import { render } from "./IYoutube.vue?vue&type=template&id=1365712e"
import script from "./IYoutube.vue?vue&type=script&lang=js"
export * from "./IYoutube.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__